// extracted by mini-css-extract-plugin
export var activeLink = "HeaderDropdown-module--activeLink--cfa7b";
export var backdrop = "HeaderDropdown-module--backdrop--512a0";
export var desc = "HeaderDropdown-module--desc--143fb";
export var heading = "HeaderDropdown-module--heading--7fa11";
export var image = "HeaderDropdown-module--image--95026";
export var lists = "HeaderDropdown-module--lists--029b6";
export var mainData = "HeaderDropdown-module--mainData--ed10a";
export var navItem = "HeaderDropdown-module--navItem--16cfc";
export var notificationIsShown = "HeaderDropdown-module--notificationIsShown--10ff0";
export var root = "HeaderDropdown-module--root--53890";
export var sideData = "HeaderDropdown-module--sideData--c0eb5";
export var textItem = "HeaderDropdown-module--textItem--d2dd4";
export var title = "HeaderDropdown-module--title--561ea";
export var wrapper = "HeaderDropdown-module--wrapper--3d969";